import { render, staticRenderFns } from "./navList.vue?vue&type=template&id=619dc6a4&scoped=true&"
import script from "./navList.vue?vue&type=script&lang=js&"
export * from "./navList.vue?vue&type=script&lang=js&"
import style0 from "./navList.vue?vue&type=style&index=0&id=619dc6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619dc6a4",
  null
  
)

export default component.exports